import classnames from 'classnames'
import useForceFocus from 'hooks/useForceFocus'
import useOnHover from 'hooks/useOnHover'
import useThemeColors from 'hooks/useThemeColors'
import React, { useRef } from 'react'
import { noop } from 'utils'

import './style.css'

type HTMLButtonProps = React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>

interface ButtonProps {
  invertColors?: boolean,
  invertOnHover?: boolean,
  forceFocus?: boolean
}

const Button = ({
  children,
  className,
  invertColors,
  invertOnHover,
  forceFocus = false,
  ...rest
}: ButtonProps & HTMLButtonProps) => {
  const { buttonStyles, foregroundStyles } = useThemeColors()
  const { hoverProps, isHovered } = useOnHover()
  const buttonRef = useRef(null)

  useForceFocus(buttonRef, forceFocus)

  const normalColors = invertColors ? foregroundStyles : buttonStyles
  const hoverColors = invertColors ? buttonStyles : foregroundStyles

  return (
    <button
      ref={buttonRef}
      className={classnames("drift-widget-button", {
        [className]: !!className,
      })}
      style={(isHovered && invertOnHover) ? { ...hoverColors } : { ...normalColors }}
      onTouchStart={noop}
      {...hoverProps}
      {...rest}
    >
      {children}
    </button>
  )
}

export default Button
